import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "../lib/api";
import { EmptyState } from "../components/shared/EmptyState";
import { RiskBadge } from "../components/shared/RiskBadge";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Users } from "lucide-react";

export default function Team() {
  const navigate = useNavigate();
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/team").then(({ data }) => setPeople(data)).catch((e) => toast.error(apiErr(e))).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="mono-label text-slate-500">CARGANDO…</div>;
  if (!people.length) return <EmptyState icon={Users} title="Tu equipo aparecerá aquí"
    description="Completa el diagnóstico para que Architect identifique a tus personas clave y su Key Person Risk."
    action={<Button onClick={() => navigate("/audit")} className="bg-amber-500 text-black hover:bg-amber-400 rounded-full font-semibold">Comenzar diagnóstico</Button>} />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-bold text-white">Equipo</h1>
        <p className="mt-1 text-slate-400">Personas clave y su riesgo de concentración.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {people.map((p) => {
          const k = p.key_person_risk;
          return (
            <div key={p.id} className="card-arch p-6" data-testid={`person-card-${p.id}`}>
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-cyan-500/15 text-cyan-400 font-semibold">{(p.name || "?")[0]}</div>
                <div className="min-w-0"><h3 className="font-head font-semibold text-white truncate">{p.name}</h3><p className="text-xs text-slate-500 truncate">{p.role || "—"}</p></div>
              </div>
              {k ? (
                <>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="mono-label text-slate-400">Key Person Risk</span>
                    <RiskBadge severity={k.label} showPulsingDot={k.label === "HIGH"} />
                  </div>
                  <p className="mt-1 font-head text-3xl font-extrabold text-amber-400">{k.score}</p>
                  <div className="mt-3 grid grid-cols-2 gap-y-1.5 text-xs text-slate-400">
                    <span>Procesos críticos: <b className="text-white">{k.critical_processes}</b></span>
                    <span>Conoc. único: <b className="text-white">{k.unique_knowledge_areas}</b></span>
                    <span>Decisiones únicas: <b className="text-white">{k.unique_decisions}</b></span>
                    <span>Backups: <b className="text-white">{k.backups_validated}/{k.backups_total}</b></span>
                  </div>
                  {k.label === "HIGH" && (
                    <Button data-testid={`person-transfer-${p.id}`} onClick={() => navigate("/app/plan")} className="mt-4 w-full bg-white/[0.06] text-white hover:bg-white/[0.1] rounded-full font-semibold">Crear proyecto de transferencia</Button>
                  )}
                </>
              ) : <p className="mt-4 text-sm text-slate-500">Sin datos de riesgo.</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
